module.exports = __webpack_public_path__ + "img/UPLOAD.ac4ded13.svg";